import React, { useState, useEffect } from "react";
import ViewModal from "../layout/viewmodal";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import swal from "@sweetalert/with-react";
import CustomeModal from "../modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteManageTodo,
  getAllToDO,
  getToDoById,
} from "../../redux/actions/todo";
import todo from "../../redux/reducers/todo";
import Table, { TableRow } from "../table";
import useDebounce from "../../Hook/useDebounce";
import Loader from "react-spinner-loader";
import {
  GETMANAGETODO,
  SET_RETAIN_PROPS,
  SAVE_TEMPORARY_DATA,
  RESET_REDUX_STATE,
  SET_PARENT_TODO_ID_FOR_COPY,
} from "../../redux/constants";
import PageSelector from "../PageSelector";
import RowsPerPageSelector from "../RowsPerPageSelector";

function ActivityTable({
  searchText,
  setDebouncedSearchText,
  loader,
  setSortField,
  setSortOrder,
  onPageChange,
  updateTable,
  setUpdateTable,
}) {
  const [deletemodal, setDeleteModal] = useState(false);
  const [editmodal, setEditModal] = useState(false);
  const [viewmodal, setViewModal] = useState(false);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState();
  const [page, setPage] = useState(1);
  const [currentPageWhileSearching, setCurrentPageWhileSearching] = useState(1);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { todoList } = useSelector((state) => state.todo);
  const { row_count } = useSelector((state) => state.auth);

  const _handleDelete = (activityId) => {
    dispatch(
      deleteManageTodo(activityId, (res) => {
        setDeleteModal(false);
        setUpdateTable(updateTable + 1);
      })
    );
  };

  /*-------------------------- Implementing Data Table with Pagination, Sorting, and Filtering ---------------------*/

  const [width, setWidth] = useState();

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 1000);

  useEffect(() => {
    if (debouncedHandleSearch) {
      // User is searching and currentPageWhileSearching is not set, store the current page
      if (currentPageWhileSearching === null) {
        setCurrentPageWhileSearching(page);
      }
      onPageChange(1);
      setPage(1);
      setDebouncedSearchText(debouncedHandleSearch);
    } else {
      // User removed search text, revert to the stored current page if it exists
      if (currentPageWhileSearching !== null) {
        onPageChange(currentPageWhileSearching);
        setPage(currentPageWhileSearching);
        setCurrentPageWhileSearching(null); // Reset currentPageWhileSearching
      }
      setDebouncedSearchText(debouncedHandleSearch);
    }
  }, [debouncedHandleSearch]);

  /*--------- Sorting To Do ------------ */
  useEffect(() => {
    if (sort) {
      onPageChange(1);
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  const TodoTable = ({ index, todoItem, name, createdAt, updatedAt }) => {
    const todoName = (
      <div className="font-semibold flex items-center">
        <div title={name} className={`w-auto overflow-hidden truncate`}>
          {name}
        </div>
        {todoItem.master_activity?.is_immutable ? (
          <span className="ml-2 px-2 py-1 bg-green-500 rounded text-white text-[10px] font-semibold">
            Tracking To Do
          </span>
        ) : (
          todoItem.master_activity_id && (
            <span className="ml-2 px-2 py-1 bg-[--bg-color-500] rounded text-white text-[10px] font-semibold">
              Master To Do
            </span>
          )
        )}
      </div>
    );
    return (
      <TableRow
        key={index}
        row={{ todoName, createdAt, updatedAt }}
        tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
      >
        <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
          <div className="space-x-3 flex items-center justify-center">
            <div title="Copy">
              <span
                // title="Copy To Do"
                className="fa-regular fa-copy text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  const payload = {
                    path: "/activity/create",
                    tempPageName: "manage todo",
                    saveData: {
                      parentToDoId: todoItem.id,
                      data: {
                        to_do_name: `${todoItem.name} Copy`,
                        to_do_description: todoItem.description,
                        to_do_type: todoItem.based_on,
                        to_do_label: todoItem.label,
                        resposible_team: todoItem.department,
                        responsible_user: todoItem.user,
                        is_mandatory_extension:
                          todoItem.mandatory_extension_request,
                      },
                      configs: [
                        {
                          title: "Allow Asset Entry",
                          description:
                            "Allow the Entry of Assets in this Task.",
                          checked: todoItem.asset_entry,
                        },
                        {
                          title: "Allow Customers to Track This To Do",
                          description:
                            "If activated customers are able to see the progress of this to do for their bookings.",
                          checked: Boolean(Number(todoItem.is_trackable)),
                        },
                        {
                          title: "Upload File",
                          description: "Allow the Upload of Files.",
                          checked: Boolean(Number(todoItem?.is_upload_allowed)),
                        },
                        {
                          title: "Extension",
                          description:
                            "Allow the Users to Request for Extension.",
                          checked: Boolean(Number(todoItem?.is_extensible)),
                        },
                        {
                          title: "Allow User Edit",
                          description:
                            "Allow Users to Edit Activity Performance.",
                          checked: todoItem?.allow_user_edit,
                        },
                      ],
                      filedata:
                        todoItem.activity_file_uploads.length === 0
                          ? todoItem.activity_file_uploads
                          : todoItem.activity_file_uploads.map((item) => {
                              const obj = {
                                activity_id: todoItem.id,
                                file_name: item.file_name,
                                is_mandatory: item.is_mandatory,
                              };
                              return obj;
                            }),
                    },
                  };
                  dispatch({ type: RESET_REDUX_STATE });
                  dispatch({
                    type: SET_PARENT_TODO_ID_FOR_COPY,
                    payload: todoItem.id,
                  });
                  dispatch({ type: SAVE_TEMPORARY_DATA, payload });
                  navigate("/activity/create");
                }}
              ></span>
            </div>

            <div title="Edit">
              <span
                className="fa-light fa-pen text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  dispatch({ type: SET_RETAIN_PROPS, payload: false });
                  setData(todoItem);
                  setEditModal(true);
                }}
              ></span>
            </div>

            <div title="Delete">
              <span
                className="fa-light fa-trash-can text-base cursor-pointer"
                style={{ color: "#eb5757" }}
                onClick={() => {
                  swal({
                    content: (
                      <CustomeModal
                        type="delete"
                        title="Are you sure?"
                        content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                        onDelete={() => _handleDelete(todoItem.id)}
                      />
                    ),
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                  });
                }}
              ></span>
            </div>
          </div>
        </td>
      </TableRow>
    );
  };
  return (
    <div className="overflow-x-auto">
      <Table
        heads={[
          { headName: "To Do", isSort: true, value: "name" },
          { headName: "Created At", isSort: true, value: "createdAt" },
          { headName: "Updated At", isSort: true, value: "updatedAt" },
          { headName: "Action", isSort: false, value: "Action" },
        ]}
        tClass="table-fixed w-full border-separate border-spacing-y-2"
        hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
        bClass="text-sm"
        thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
        setSort={setSort}
        sort={sort}
      >
        {loader ? (
          <tr className="px-2 py-3 whitespace-nowrap">
            <td colSpan={4}>
              <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                <Loader show={loader} />
              </div>
            </td>
          </tr>
        ) : todoList.activities?.length > 0 ? (
          todoList.activities.map((todoItem, index) => {
            const { name } = todoItem;
            const updatedAt = moment(todoItem.updatedAt).format(
              "DD MMM, YYYY - HH:mm a"
            );
            const createdAt = moment(todoItem.createdAt).format(
              "DD MMM, YYYY - HH:mm a"
            );
            return (
              <TodoTable
                index={index}
                todoItem={todoItem}
                name={name}
                createdAt={createdAt}
                updatedAt={updatedAt}
              />
            );
          })
        ) : (
          <td
            colSpan={4}
            className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
          >
            There are no records to display
          </td>
        )}
      </Table>
      {!loader && (
        <div className="flex justify-between items-center">
          <RowsPerPageSelector />
          <PageSelector
            rowPerPage={row_count}
            page={page}
            setpage={(newPage) => {
              onPageChange(newPage);
              setPage(newPage);
            }}
            totalDataCount={todoList.totalCount}
          />
        </div>
      )}
      <ViewModal
        id={data}
        searchId="view"
        modalOpen={viewmodal}
        setModalOpen={setViewModal}
      />
      {editmodal && navigate("/activity/update", { state: data })}
    </div>
  );
}

export default ActivityTable;
